import React from 'react'
import styled from 'styled-components'
import NavButton, {
  NavButtonWithSize,
} from 'Event/Dashboard/components/NavButton'
import {Editable} from 'Event/Dashboard/editor/views/EditComponent'
import Published from 'Event/Dashboard/editor/views/Published'
import {Draggable} from 'react-beautiful-dnd'
import {DraggableOverlay} from 'lib/ui/drag-and-drop'
import {useEditMode} from 'Event/EditModeProvider'
import {useToggle} from 'lib/toggle'
import {SidebarNavButtonConfig} from 'Event/template/SimpleBlog/Dashboard/Sidebar/SidebarItem/SidebarNav/SidebarNavButtonConfig'
import {useLoadFont} from 'lib/FontSelect'
import {SidebarNavProps} from 'Event/template'

export default React.memo(
  (
    props: NavButtonWithSize & {
      id: string
      index: number
      nav: SidebarNavProps
      navId: string
    },
  ) => {
    const isEditMode = useEditMode()

    const {flag: configVisible, toggle: toggleConfig} = useToggle()
    const {flag: showingCopyConfig, toggle: toggleCopyConfig} = useToggle()

    useLoadFont(props.font)

    const edit = () => {
      toggleConfig()
    }

    const button = (
      <Published component={props}>
        <StyledNavButtonComponent
          aria-label="sidebar nav button"
          textColor="#FFFFFF"
          borderWidth={1}
          borderColor="#FFFFFF"
          onClick={isEditMode ? edit : () => {}}
          {...props}
        />
      </Published>
    )

    if (!isEditMode) {
      return button
    }

    return (
      <>
        <SidebarNavButtonConfig
          nav={props.nav}
          button={props}
          id={props.id}
          showing={configVisible}
          onClose={toggleConfig}
          navId={props.navId}
        />
        <SidebarNavButtonConfig
          nav={props.nav}
          button={props}
          showing={showingCopyConfig}
          onClose={toggleCopyConfig}
          navId={props.navId}
        />
        <Draggable draggableId={props.id} index={props.index}>
          {(provided) => (
            <div ref={provided.innerRef} {...provided.draggableProps}>
              <DraggableOverlay>
                <Editable
                  onEdit={edit}
                  onCopy={toggleCopyConfig}
                  handleProps={provided.dragHandleProps}
                >
                  <>{button}</>
                </Editable>
              </DraggableOverlay>
            </div>
          )}
        </Draggable>
      </>
    )
  },
)

const StyledNavButtonComponent = styled(NavButton)`
  font-size: 14px;
  padding: ${(props) => `${props.theme.spacing[3]} ${props.theme.spacing[4]}`};
  margin: ${(props) => props.theme.spacing[3]} 0;
`
